import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { SCREEN_SIZE } from 'types';
import { selectScreenSize } from 'redux/session/selectors';
import { HeaderMenuButton } from 'carbon-components-react/lib/components/UIShell';
import AppSwitcher from 'components/AppSwitcher';
import { TopHeaderLogo, AuthGlobalToolBar } from './HeaderGlobalBar';

const TopHeader: React.FC<Props> = (props: Props) => {
  const {
    disableNav,
    enableHeaderGlobalBar,
    isSideNavExpanded,
    hamburgerMenuHandler,
    showLeftHandSideNav
  } = props;
  const screenSize = useSelector(selectScreenSize) || SCREEN_SIZE.MAX;
  const bigScreens = [SCREEN_SIZE.MAX, SCREEN_SIZE.XL, SCREEN_SIZE.LG];

  return (
    <>
      {!bigScreens.includes(screenSize) && showLeftHandSideNav && (
        <HeaderMenuButton
          className="burger-menu-button bx--col-md-0 bx--col-lg-0"
          aria-label="Open menu"
          isCollapsible
          onClick={() => hamburgerMenuHandler()}
          isActive={!!isSideNavExpanded}
        />
      )}
      <TopHeaderLogo
        disableNav={disableNav === null ? undefined : disableNav}
      />
      {screenSize && screenSize !== SCREEN_SIZE.SM && <AppSwitcher />}
      {enableHeaderGlobalBar && (
        <AuthGlobalToolBar
          disableNav={disableNav === null ? undefined : disableNav}
        />
      )}
      {props.children && <div className="child--wrapper">{props.children}</div>}
    </>
  );
};

const propTypes = {
  disableNav: PropTypes.bool,
  enableHeaderGlobalBar: PropTypes.bool,
  role: PropTypes.string,
  children: PropTypes.any,
  showBurgerMenuButton: PropTypes.bool,
  isSideNavExpanded: PropTypes.bool,
  hamburgerMenuHandler: PropTypes.func.isRequired,
  screenWidth: PropTypes.number,
  showLeftHandSideNav: PropTypes.bool
};

type Props = PropTypes.InferProps<typeof propTypes>;

TopHeader.propTypes = propTypes;

TopHeader.defaultProps = {
  disableNav: undefined,
  enableHeaderGlobalBar: false,
  showBurgerMenuButton: true,
  isSideNavExpanded: false,
  hamburgerMenuHandler: () => {},
  showLeftHandSideNav: true
};

export default React.memo(TopHeader);
